import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';

import { PAGE_NAME_STEPS, EorderWizardService } from '../services/eorder-wizard.service';
import { EorderWizardStep } from '../models/eorder-wizard-state';

function getStepIndex(url: string) {
	for (const [i, PAGE_NAME_STEP] of PAGE_NAME_STEPS.entries()) {
		if (url.includes(PAGE_NAME_STEP)) {
			return i;
		}
	}
	if (url.includes('template')) {
		return EorderWizardStep.ORDERINFORMATION; // access to template from informations and selection step
	}
	return EorderWizardStep.ORDERINFORMATION;
}

export const eorderWizardEnterGuard: CanActivateFn = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const eorderWizardService: EorderWizardService = inject(EorderWizardService);
	const stepIndex = getStepIndex(state.url);
	eorderWizardService.checkWizardStateValidity(stepIndex);
	return true;
};
